import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Settings, Users, ClipboardList, BellRing, Megaphone } from 'lucide-react';
import { userCanAccessCrmMarketing, userCanEditCrm } from '@/lib/crmApi';

const CrmNavLinks = ({ user, size = 'sm', showIcons = true, adminOnly = false }) => {
  const location = useLocation();

  const canSeeCrm = adminOnly ? !!user?.is_admin : userCanEditCrm(user);
  const canSeeMarketing = adminOnly ? !!user?.is_admin : userCanAccessCrmMarketing(user);
  if (!canSeeCrm && !canSeeMarketing) {
    return null;
  }

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`);
  const crmNavClass = (path) =>
    isActive(path)
      ? 'bg-slate-900 text-white hover:bg-slate-800 hover:text-white'
      : '';

  const iconClass = showIcons ? 'w-5 h-5 mr-2' : 'w-5 h-5';

  return (
    <>
      {canSeeCrm ? (
        <>
          <Link to="/crm/clients" data-testid="crm-clients-button">
            <Button variant="ghost" size={size} className={crmNavClass('/crm/clients')}>
              <Users className={iconClass} />
              Клиенты CRM
            </Button>
          </Link>
          <Link to="/crm/customer-orders" data-testid="crm-customer-orders-button">
            <Button variant="ghost" size={size} className={crmNavClass('/crm/customer-orders')}>
              <ClipboardList className={iconClass} />
              Заказы покупателей
            </Button>
          </Link>
          <Link to="/crm/stock-watches" data-testid="crm-stock-watches-button">
            <Button variant="ghost" size={size} className={crmNavClass('/crm/stock-watches')}>
              <BellRing className={iconClass} />
              Ожидание наличия
            </Button>
          </Link>
          <Link to="/crm/settings" data-testid="crm-settings-button">
            <Button variant="ghost" size={size} className={crmNavClass('/crm/settings')}>
              <Settings className={iconClass} />
              Настройки CRM
            </Button>
          </Link>
        </>
      ) : null}
      {canSeeMarketing ? (
        <Link to="/crm/marketing" data-testid="crm-marketing-button">
          <Button variant="ghost" size={size} className={crmNavClass('/crm/marketing')}>
            <Megaphone className={iconClass} />
            Контент
          </Button>
        </Link>
      ) : null}
    </>
  );
};

export default CrmNavLinks;
